import { render } from "./TestRequestTable.vue?vue&type=template&id=7cbaac7e&scoped=true"
import script from "./TestRequestTable.vue?vue&type=script&lang=js"
export * from "./TestRequestTable.vue?vue&type=script&lang=js"

import "./TestRequestTable.vue?vue&type=style&index=0&id=7cbaac7e&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2517490718/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7cbaac7e"]])

export default __exports__